"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapFactory = void 0;
;
var Map_1 = require("./Map");
var proj4_1 = require("proj4");
var ste_simple_events_1 = require("ste-simple-events");
var Map_2 = require("ol/Map");
var View_1 = require("ol/View");
var ScaleLine_1 = require("ol/control/ScaleLine");
var Attribution_1 = require("ol/control/Attribution");
var interaction_1 = require("ol/interaction");
var control_1 = require("ol/control");
var proj4_2 = require("ol/proj/proj4");
proj4_1.default.defs([
    [
        'EPSG:27700',
        '+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.999601 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +no_defs +towgs84=446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894'
    ]
]);
var MapFactory = /** @class */ (function () {
    function MapFactory() {
        var _this = this;
        this._onLayerInitialised = new ste_simple_events_1.SimpleEventDispatcher();
        this.instance = function (opts, mapStore, logger, vectorSourceLayerFactory, baseLayerFactory, boundsLoaderBehaviour, contextMenu, printOptions, filters, mappingTextPack) {
            proj4_2.register(proj4_1.default);
            var options = {
                target: opts.mapElementId,
                view: new View_1.default({
                    projection: opts.displayProjection,
                    zoom: 10,
                    minZoom: opts.minZoom || 8,
                    maxZoom: opts.maxZoom || 19,
                    extent: opts.extent,
                    constrainOnlyCenter: opts.constrainOnlyCenter || true,
                    constrainResolution: true // force zooming to a integer zoom
                }),
                controls: control_1.defaults({
                    zoomOptions: {
                        zoomOutTipLabel: mappingTextPack.zoomOut,
                        zoomInTipLabel: mappingTextPack.zoomIn
                    },
                    attributionOptions: {
                        tipLabel: mappingTextPack.attributions,
                        collapsed: true,
                        collapsible: true
                    }
                })
            };
            if (printOptions && !opts.staticMap) {
                var attribution = new Attribution_1.default(printOptions.attribution);
                var scaleLine = new ScaleLine_1.default(printOptions.scaleLine);
                var controls = control_1.defaults({
                    attribution: false
                }).extend([attribution, scaleLine]);
                options.controls = controls;
            }
            if (opts.staticMap === true) {
                options.interactions = interaction_1.defaults({
                    altShiftDragRotate: false,
                    dragPan: false,
                    doubleClickZoom: false,
                    keyboard: false,
                    mouseWheelZoom: false,
                    shiftDragZoom: false,
                    pinchZoom: false,
                    pinchRotate: false
                });
                options.controls = control_1.defaults({
                    rotate: false,
                    zoom: false
                });
            }
            else {
                //disable pinch rotate & disallow fractional zooming with pinch zoom
                options.interactions = interaction_1.defaults({
                    pinchRotate: false,
                    pinchZoom: false
                }).extend([
                    new interaction_1.PinchZoom()
                ]);
                if (opts.dragRotateAndZoom === true) {
                    options.interactions.extend([
                        new interaction_1.DragRotateAndZoom()
                    ]);
                }
            }
            var openLayersMap = new Map_2.default(options);
            var _map = new Map_1.olMap(openLayersMap, opts, mapStore, logger, boundsLoaderBehaviour, contextMenu, filters, mappingTextPack);
            mapStore.initMap(_map.olMap, opts.enableBoundsTracking);
            _map.olMap.addControl(new ScaleLine_1.default());
            var fs = document.createElement('i');
            fs.setAttribute('class', 'fa fa-expand');
            _map.olMap.addControl(new control_1.FullScreen({
                label: fs,
                tipLabel: mappingTextPack.toggleFullScreen
                //target:document.getElementById("mapContainer")
            }));
            _this.addBaseMaps(_map, opts, mapStore, baseLayerFactory);
            _this.setMapView(_map, opts, mapStore);
            _this.addLayers(_map, mapStore, vectorSourceLayerFactory, opts.layerGroupCollection);
            _map.addOnMapZoomHandler();
            if (contextMenu != null) {
                _map.contextMenu.addToMap(_map);
            }
            return _map;
        };
        this.setMapView = function (m, opts, mapStore) {
            var lastmapSettings = mapStore.getMapInfo();
            // only move map if there is no data to zoom to
            if (lastmapSettings.centre && lastmapSettings.zoom) {
                m.olMap.getView().setCenter(lastmapSettings.centre);
                m.olMap.getView().setZoom(lastmapSettings.zoom);
            }
            else {
                //zoom to defaults if we don't have any on the cookie
                m.olMap.getView().setCenter(opts.mapCentre);
                m.olMap.getView().setZoom(opts.mapZoom);
            }
        };
        this.addBaseMaps = function (map, opts, mapStore, baseLayerFactory) {
            var lyr;
            var lyrType;
            var hasVisibleBaseLayer = false;
            var lastBaseLayers = mapStore.getMapInfo().baselayers;
            var getVisibility = function (layerName, baseMapType) {
                //  jk - fix bug here for LHLP always loading last layer: lastBaseLayers.size ===0
                return (lastBaseLayers.get(layerName) === true || (lastBaseLayers.size === 0 && opts.defaultBaseMap === baseMapType));
            };
            for (var i = 0; opts.baseMaps.length > i; i++) {
                lyrType = opts.baseMaps[i];
                lyr = baseLayerFactory.GetBaseLayerByType(lyrType, opts.bingApiKey, opts.esdmOsmApiKey);
                lyr.addLayerToMap(map, getVisibility(lyr.ref, lyrType));
                if (lyr.getVisible()) {
                    hasVisibleBaseLayer = true;
                    //make sure the default is set
                    mapStore.onBaseLayerChanged(lyr.ref, true);
                }
                map.baseLayers.push(lyr);
            }
            if (!hasVisibleBaseLayer && lyr) {
                //set the last layer to be visible
                lyr.setVisible(true);
                //make sure the default is set
                mapStore.onBaseLayerChanged(lyr.ref, true);
            }
        };
        this.addLayers = function (map, mapStore, vectorLayerSourceFactory, layerGroupCollection) {
            if (layerGroupCollection !== null && layerGroupCollection.allLayers !== null) {
                var layersReversed = __spreadArray([], layerGroupCollection.allLayers);
                layersReversed.reverse();
                for (var _i = 0, layersReversed_1 = layersReversed; _i < layersReversed_1.length; _i++) {
                    var lg = layersReversed_1[_i];
                    if (layerGroupCollection.isVectorLayerGroup(lg)) {
                        //add vector layer group
                        _this.addVectorLayerGroup(map, mapStore, vectorLayerSourceFactory, lg);
                    }
                    else {
                        //add wms layer group
                        _this.addWmsLayerGroup(map, mapStore, lg);
                    }
                }
            }
        };
        this.addVectorLayerGroup = function (map, mapStore, vectorLayerSourceFactory, layerGroup) {
            var zoom = map.olMap.getView().getZoom();
            layerGroup.setLayerSources(map, vectorLayerSourceFactory);
            for (var _i = 0, _a = layerGroup.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                lyr.setInitialVisibility(zoom, mapStore, layerGroup.visibleOnLoad);
                _this._onLayerInitialised.dispatch({
                    layer: lyr
                });
                map.addVectorLayer(lyr);
            }
        };
        this.addWmsLayerGroup = function (map, mapStore, layerGroup) {
            var zoom = map.olMap.getView().getZoom();
            for (var _i = 0, _a = layerGroup.layers; _i < _a.length; _i++) {
                var lyr = _a[_i];
                //add wms layer            
                lyr.setSource(map);
                lyr.setInitialVisibility(zoom, mapStore, layerGroup.visibleOnLoad);
                map.addWmsLayer(lyr);
            }
        };
    }
    Object.defineProperty(MapFactory.prototype, "onLayerInitialised", {
        get: function () {
            return this._onLayerInitialised.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    return MapFactory;
}());
exports.MapFactory = MapFactory;
//# sourceMappingURL=MapFactory.js.map